module.exports = __webpack_public_path__ + "img/west-vvip-gal-12.c6420d4a.jpg";